function exportCsvData(exportData, fileName) {
    // Escape and join
    const csvData = exportData.map((row) => row.map(escapeCSV)
        .join(','))
        .join('\n')

    // Create a Blob and temporary link
    const blob = new Blob([csvData], { type: 'text/csv charset=utf-8' })
    const link = document.createElement('a')

    link.href = URL.createObjectURL(blob)
    link.download = fileName

    // // Append to DOM, click, and clean up
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}


function escapeCSV(value) {
    if (value === null || value === undefined) {
        return '';
    }
    const stringValue = String(value)
    // Escape formulas
    let safeValue = /^[=+\-@]/.test(stringValue) ? `'${stringValue}` : stringValue
    // Check if value contains a comma, double quote, or newline
    if (/[",\n\r]/.test(safeValue)) {
        // Escape double quotes by doubling them and wrap in quotes
        return `"${safeValue.replace(/"/g, '""')}"`;
    }
    return safeValue;
}

export default {
    exportCsvData
}
